<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="content">
        <!-- <div class="goback">
          <div @click="goback">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
        </div> -->
        <div class="result">
          <div class="imgXing">
            <img src="@/assets/evaluation/xingxing.png" alt="" />
            <img :src="result.icon" alt="" />
          </div>
          <div class="con">
            <div class="title">
              {{ result.evaluatePersonnelName }}, 高潜力识别诊断结果
            </div>
            <div class="value">
              分数代表个体在当前时刻的潜在能力。潜力越大，意味着个体在组织内更高级职位上取得成功的可能性越大。以下是潜力各个方面的分数及其潜力评级。
            </div>
            <div class="score">
              <div v-for="item in scoreList" :key="item.label">
                <div class="val">{{ item.value }}</div>
                <div class="label">{{ item.label }}</div>
              </div>
            </div>
            <div class="detail">
              <div class="title">结论</div>
              <div class="text">{{ result.conclusion }}</div>
            </div>
          </div>
        </div>
        <!-- <div class="potential">
          <div class="title">潜在评级</div>
          <div class="itemList" v-for="item in potentialList" :key="item.id">
            <div class="top">
              <div class="round"></div>
              <div class="label">评分</div>
            </div>
            <div class="score" v-if="item.capacity">
              <div>能力：{{ item.capacity }}</div>
              <div>抱负：{{ item.ambition }}</div>
              <div>敬业度：{{ item.workEngagement }}</div>
            </div>
            <div class="score" v-else>其他任何分数</div>
            <div class="conclusion">结论</div>
            <div class="text">{{ item.conclusion }}</div>
            <div class="solid" v-if="item.capacity"></div>
          </div>
        </div> -->
        <div class="potential">
          <div class="title" style="margin-bottom: 15px">评分明细</div>
          <el-table :data="tableList" :row-class-name="tableRowClassName">
            <el-table-column
              prop="relation"
              label="评价者"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="capacity"
              label="能力"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ambition"
              label="抱负"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="workEngagement"
              label="敬业度"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <!-- <div class="footer" v-if="!id">
        <el-button class="btn1" @click="submit" :disabled="!disabledNext"
          >提交</el-button
        >
        <el-button class="btn2" @click="next" :disabled="disabledNext"
          >考评下一个</el-button
        >
      </div> -->
    </div>
  </div>
</template>

<script>
import api from "@/apis/evaluation";
export default {
  components: {},
  data() {
    return {
      params: {},
      id: "",
      result: {},
      scoreList: [
        {
          label: "能力",
          value: "",
        },
        {
          label: "抱负",
          value: "",
        },
        {
          label: "敬业度",
          value: "",
        },
      ],
      potentialList: [],
      disabledNext: true,
      tableList: [],
    };
  },
  mounted() {
    // const { id, data } = this.$route.query;
    // if (id) {
    //   console.log("111");
    //   this.id = id
    //   this.getDetail(id);
    // } else {
    //   this.params = JSON.parse(data);
    //   this.getResult();
    // }
    const { evaluatePersonnelCode } = this.$route.query;
    if (evaluatePersonnelCode) {
      this.getDetail();
    }
    // this.getPotential();
  },
  methods: {
    //跳转
    toUrl(path) {
      this.$router.push(path);
    },
    //跳转
    goback() {
      this.$router.push("/evaluation");
    },
    //获取考评结果
    getDetail() {
      const { evaluatePersonnelCode, activityId } = this.$route.query;
      api
        .evaluateManageQueryConclusionVo({ evaluatePersonnelCode, activityId })
        .then((res) => {
          if (res.code == 200) {
            console.log(res);
            this.result = res.data;
            this.scoreList[0].value = this.result.capacity;
            this.scoreList[1].value = this.result.ambition;
            this.scoreList[2].value = this.result.workEngagement;
            this.tableList = res.data.manageList;
          }
        });
    },
    // 根据行的状态添加类名
    tableRowClassName({ row }) {
      // 根据行的状态添加类名
      if (row.relation == "总分" || row.relation == "结论") {
        return "active-row";
      }
    },
    // submit() {
    //   api.evaluateManageAdd(this.params).then((res) => {
    //     if (res.code == 200) {
    //       this.$message({
    //         type: "success", // success error warning
    //         message: "提交成功",
    //         duration: 2000,
    //       });
    //       this.disabledNext = false;
    //       sessionStorage.removeItem("evaluationObject");
    //       // sessionStorage.removeItem("params");
    //     }
    //   });
    // },
    // next() {
    //   this.$router.push({
    //     path: "/evaluation/object",
    //     query: {
    //       type: 2,
    //     },
    //   });
    // },
    // getResult() {
    //   api.evaluateManageQueryConclusion(this.params).then((res) => {
    //     if (res.code == 200) {
    //       console.log(res);
    //       this.result = res.data;
    //       this.scoreList[0].value = this.result.capacity;
    //       this.scoreList[1].value = this.result.ambition;
    //       this.scoreList[2].value = this.result.workEngagement;
    //     }
    //   });
    // },
    // getPotential() {
    //   api.evaluateConclusionList().then((res) => {
    //     if (res.code == 200) {
    //       console.log(res);
    //       this.potentialList = res.data;
    //     }
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox,
  .footer {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 306px * $zoom;
    ::v-deep {
      .van-dropdown-item {
        width: 306px * $zoom !important;
        margin: auto;
      }
    }
  }
  .footer {
    width: 306px * $zoom;
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  min-height: 100vh;
  padding-top: 30px;
  background: url("~@/assets/evaluation/bg3.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;

  .goback {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;

    div {
      display: flex;
      align-items: center;
    }

    i {
      font-weight: bold;
      font-size: 48px;
      margin-right: 40px;
    }

    span {
      font-size: 34px;
      flex-shrink: 0;
    }

    .goback_search {
      margin-left: 20px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 80px;
      height: 80px;
      // width: 58vw;
      padding: 0 30px 0 10px;

      align-items: center;
      justify-content: space-between;

      ::v-deep .el-input {
        flex: 1;
        height: 100%;

        &__inner {
          height: 100%;
          border: none;
          font-size: 28px;
          border-radius: 80px;
        }
      }

      i {
        font-size: 38px;
        margin-right: 10px !important;
      }
    }
  }
  .content {
    flex: 1;
    padding: 30px 40px 40px;
    position: relative;
    overflow: auto;
    // margin-bottom: 120px;
    margin-bottom: 30px;
    // 隐藏滚动条
    ::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }
    .result {
      width: 100%;
      background: #fff;
      border-radius: 30px;
      padding: 120px 30px 40px;
      position: relative;
      margin-top: 100px;
      .imgXing {
        position: absolute;
        top: -110px;
        left: 50%;
        transform: translateX(-50%);
        width: 280px;
        height: 192px;
        img:nth-child(1) {
          width: 100%;
          height: 100%;
        }
        img:nth-child(2) {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          position: absolute;
          top: 68px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .con {
        .title {
          font-size: 34px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 20px;
        }
        .value {
          // 首行缩进
          text-indent: 2em;
          font-size: 28px;
          color: #666666;
          line-height: 44px;
        }
        .score {
          display: flex;
          justify-content: space-around;
          margin: 30px 0;
          .val {
            font-size: 38px;
            color: #1fbe8a;
            margin-bottom: 15px;
            text-align: center;
          }
          .label {
            font-size: 28px;
            color: #666;
          }
        }
        .detail {
          background: #fafafa;
          padding: 30px;
          border-radius: 30px;
          .title {
            font-size: 28px;
            font-weight: bold;
            color: #000;
            text-align: left;
          }
          .text {
            font-size: 28px;
            color: #666;
            line-height: 44px;
          }
        }
      }
    }
    .potential {
      width: 100%;
      background: #fff;
      border-radius: 30px;
      padding: 40px 30px;
      margin-top: 30px;
      .title {
        font-size: 30px;
        font-weight: bold;
        color: #000;
        text-align: left;
      }
      .itemList {
        .top {
          display: flex;
          align-items: center;
          font-size: 28px;
          color: #000;
          font-weight: bold;
          margin-top: 30px;
          .round {
            width: 15px;
            height: 15px;
            background: #1fbe8a;
            border-radius: 50%;
            margin-right: 20px;
          }
        }
        .score {
          display: flex;
          padding: 0 30px 0 20px;
          align-items: center;
          margin-top: 20px;
          justify-content: space-between;
          color: #666;
          font-size: 28px;
        }
        .conclusion {
          font-size: 28px;
          color: #000;
          font-weight: bold;
          margin-top: 30px;
          padding-left: 20px;
        }
        .text {
          font-size: 28px;
          margin-top: 20px;
          line-height: 40px;
          color: #666;
          padding-left: 20px;
        }
        .solid {
          width: 100%;
          height: 2px;
          background: #ebedf0;
          margin-top: 30px;
        }
      }
    }
    .btn {
      .el-button {
        width: 100%;
        height: 90px;
        background: #1fbe8a;
        border-radius: 10px;
        font-size: 28px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 60px;
      }
    }
  }
  .footer {
    height: 120px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    button {
      width: 40%;
      height: 80px;
      border-radius: 15px;
    }
    .btn1 {
      margin-right: 5%;
      border: 1px solid #1fbe8a;
      color: #1fbe8a;
      background: #fff;
    }
    .btn2 {
      border: 1px solid #1fbe8a;
      background: #1fbe8a;
      color: #fff;
    }
    .is-disabled:nth-child(1) {
      border: 1px solid #96e1c8;
      color: #96e1c8;
      background: none;
    }
    .is-disabled:nth-child(2) {
      background: #96e1c8;
      border: 1px solid #96e1c8;
      color: #fff;
    }
  }
  ::v-deep {
    .el-table .el-table__cell.is-center {
      border-bottom: none;
    }
    .el-table::before {
      background: none;
    }
    .active-row{
      color: #1FBE8A;
      font-weight: bold;
      td:nth-child(1){
        color: #000;
      }
    }
    .cell{
      font-size: 28px;
    }
  }
}
</style>
